<template>
<div>
    <div class="cancel-reservation">
	<div class="container">
		<div class="row justify-content-center">
			<div class="col-md-12">
			<div class="card">
				<div class="card-header bg-white border-0">
					<div class="row align-items-center">
						<div class="col-8">
							<h3 class="mb-0 text-left">{{$t("actions.cancelReservation")}} {{reservation.customerId}}</h3>
						</div>
                        <div class="col-4 text-right">
                            <button class="btn btn-sm btn-primary" @click="$router.go(-1)">{{$t('actions.back')}}</button>
						</div>
					</div>
					<hr>
				</div>
                <div class="card-body">
                    <div v-show="isLoading">
                        <div class="spinner-border text-warning" role="status"><span class="sr-only">Loading...</span></div>
                    </div>
                    <div v-show="!isLoading">
                        <!-- <div class="row justify-content-center">
                            <div class="item-row col-4">
                                <div class="text-left">
                                    <b>Pickup point:</b> {{reservation.from.address}}
                                </div>
                                <div class="text-left" v-show="reservation.from.address != reservation.from.addressName">
                                    <b>Pickup address:</b> {{reservation.from.addressName}}
                                </div>
                                 <div class="text-left">
                                    <b>Pickup date:</b> {{reservation.pickupDateString}} <br>
                                    <b>Pickup time:</b> {{reservation.pickupTimeString}}
                                </div>
                            </div>
                            <div class="item-row col-4">
                                 <div v-show="reservation.bookingType !== 2">
                                    <div>
                                        <b>Drop-off point:</b> {{reservation.to.addressName}}
                                    </div>
                                    <div v-show="reservation.to.addressName != reservation.to.address">
                                        <b>Drop-off address:</b> {{reservation.to.address}}
                                    </div>
                                </div>
                                <div class="text-left" v-show="reservation.bookingType === 2">
                                    <span class="item-details"> <b>Booked for:</b> {{reservation.durationInHours}} hours</span>
                                </div>                                
                                <div class="text-left" v-show="reservation.numberOfCars > 0">
                                    <b>Drivers:</b> {{reservation.numberOfCars}}
                                </div>
                                <div class="text-left">
                                    <b>Booking price:</b> {{reservation.totalPrice | round(2, true)}} {{reservation.currency}}
                                </div>

                            </div>
                        </div> -->
                        <div class="row">                         
                            <div class="col-sm-12 text-center mb-2">
                                <h4 v-show="reservation.clientCancellationCost > 0">Cancellation cost: {{reservation.clientCancellationCost | round(2, true)}} {{reservation.currency}}</h4>
                                <h4 class="text-success" v-show="reservation.clientCancellationCost == 0">This booking has free cancellation</h4>
                            </div>
                        </div>
                        <div class="row justify-content-center">
                            <div class="col-6 col-sm-12">
                                <div class="form-group">
                                    <select class="form-control" name="reason" v-model="reservation.reason">
                                        <option selected="selected"></option>
                                        <option value="No longer traveling or change of plans">No longer traveling or change of plans</option>
                                        <option value="Event was canceled">Event was canceled</option>
                                        <option value="Found a better price elsewhere">Found a better price elsewhere</option>
                                        <option value="I booked by mistake these dates">I booked by mistake these dates</option>
                                    </select>
                                    <div v-if="$v.reservation.reason.$dirty">
                                        <div class="text-danger" v-if="$v.reservation.reason.$dirty && !$v.reservation.reason.required">
                                        Please select cancellation reason.
                                        </div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <textarea class="form-control" rows="5" name="reasonDescription" v-model="reservation.reasonDescription"
                                            placeholder="Reason details ..."></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="row">                         
                            <div class="col-sm-12 text-center mt-3">
                                <!-- <h4 v-show="reservation.cancellationCost.clientCost > 0">Cancellation cost: {{reservation.cancellationCost.clientCost | round(2, true)}} {{reservation.currency}}</h4>
                                <h4 class="text-success" v-show="reservation.cancellationCost.clientCost == 0">This booking has free cancellation</h4> -->

                                <button class="btn btn-danger" @click="cancelBooking()">Cancel
                                    <span v-show="reservation.clientCancellationCost > 0"> - {{reservation.clientCancellationCost}} {{reservation.currency}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
			</div>
            </div>
        </div>
	</div>    
    </div>
</div>
</template>

<script>
import Vue from 'vue';
import { mapActions } from "vuex";
import { round } from "../utils/filters.js";
import Vuelidate from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import HtmlPageService from "../services/htmlPageService"

Vue.use(Vuelidate);

export default {
    data() {
        return {
            isLoading: true,
            reservation: {
                cancellationCost: {},
                canCancel: false,
                from: {},
                to: {},
                reason: null,
                reasonDescription: null
            },
        };
    },
     validations: {
        reservation:{
            reason: { required }
        }
    },
    computed: {
    },
    filters: {
        round: round
    },
    created() {
        this.getReservationCancellationInfo(this.$route.params.id).then(result=>{
            console.log("getClientReservations result:", result);
            this.reservation = result
            this.isLoading = false;
        });
    },
    methods: {
        ...mapActions("booking", ["getReservationCancellationInfo", "cancelReservation"]),
        cancelBooking: function() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.cancelReservation(this.reservation).then(() => {
                    this.$router.go(-1);
                });
            } else {
                //scroll to first form error
                HtmlPageService.scrollElement('.error', 10)
            }
        }
    }
}
</script>